import Axios, { Response } from '../utils/Axios';
import AsyncLocalStorage from '../utils/AsyncLocalStorage';

export type OrderHistory = {
  order: Order;
};

export type Order = {
  order_id?: string;
  table_area_nr?: number;
  table_nr?: number;
  is_active?: number;
  is_complete?: number;
  completed_at?: null | string;
  child?: OrderChild[];
};

export type OrderChild = {
  confirmed_at?: string;
  delivery_tip?: string;
  order_seq?: number;
  order_status: number;
  ordered_at: string;
  payment_type: number;
  payment_status: number;
  bill_number: string;
  order_nr: null | number;
  order_service: number;
  order_type: number;
  total_amount_org: number;
  discount_amount: number;
  tax: number;
  total_amount_incl: number;
  prepared_at: null | string;
  picked_up_at: null | string;
  cancelled_at: null | string;
  cancel_description: null | string;
  detail: Product[];
  store_discount_amount?: number;
  com_discount_amount?: number;
  delivery_address?: string;
  store_name?: string;
  hotel_name?: string;
  coupons?: Coupon[];
  store_phone_number:string;
};

export type Product = {
  product_id: number;
  product_seq: number;
  set_product_seq: number;
  product_name: string;
  is_set: number;
  has_option: number;
  product_status: number;
  product_price: number;
  product_discount_name: '';
  product_discount: number;
  product_discount_amount: number;
  product_quantity: number;
  product_org_price: number;
  product_tax: number;
  product_tax_name: null | string;
  product_tax_rate: string;
  product_total_amount: number;
  request_id: number;
  request_message: string;
  prepared_at: string;
  cancelled_at: string;
  cancel_description: string;
  options: Option[];
  set_options: Product;
  set_prd_type_list: SetMenuGroup[];
};

export type Option = {
  option_id: number;
  option_name: string;
  option_price: number;
  option_type_id?: number;
  option_type_name?: number;
};
export type SetMenuGroup = {
  set_prd_type_id: number;
  set_prd_type_min: number;
  set_prd_type_name: string;
  set_product: SetMenu[];
};
export type SetMenu = {
  product_id: number;
  product_name: string;
  product_total_amount: number;
  product_price: number;
  options: Option[];
};
export type Coupon = {
  coupon_id: number;
  coupon_name: string;
  coupon_detail_id: number;
  com_discount_amount: number;
  store_discount_amount: number;
  used_at: string;
};

const OrderController = {
  // getHisDetail: async (oParams: any): Promise<Response> => {
  //   try {
  //     let sUrl = process.env.REACT_APP_API_BEHIND_URL + '/order/hisDetail';
  //     const response: any = await Axios.post(sUrl, oParams);
  //     return response;
  //   } catch (err) {
  //     let oErr: any = err;
  //     return {
  //       ok: false,
  //       msg: '[로그인 오류]' + oErr.toString(),
  //       data: undefined,
  //       status: 500,
  //     };
  //   }
  // },
  setOrderCancel: async (oParams: any): Promise<Response> => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_LOGIN_URL + '/api/order/cancelForce';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[주문 강제 취소 오류]' + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },
  setOrderCancelPause: async (oParams: any): Promise<Response> => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_LOGIN_URL + '/api/order/cancelPause';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[주문 자동취소 일시정지 오류]' + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },
  readyAdminForce: async (oParams: any): Promise<Response> => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_LOGIN_URL + '/order/readyAdminForce';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[강제 주문 접수 오류]' + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },
  completeOrderForce: async (oParams: any): Promise<Response> => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/admin/completeOrderForce';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[강제 배달 완료 오류]' + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },
  cancelAdminForce:async (oParams: any): Promise<Response> => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_LOGIN_URL + '/order/cancelAdminForce';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[강제 주문 취소 오류]' + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },
  setPause:async (oParams: any): Promise<Response> => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/store/setPause';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[강제 매장 오픈(일시정지) 오류]' + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },
};

export default OrderController;
